module.exports = __webpack_public_path__ + "img/touXiang5.2204631d.png";